import axios from 'axios';

import { downloadFileFromResponse } from 'src/helpers/downloadFileFromResponse';
import type { GoodServiceCodeFileUploadResponse } from 'src/interfaces/GoodServiceCodes';

export const downloadGoodServiceCodesTemplateUri =
	'/api/gtdcm/v1/good-service-codes/template';
export async function downloadGoodServiceCodesTemplate() {
	const response = await axios.get<string>(downloadGoodServiceCodesTemplateUri);

	downloadFileFromResponse(
		[response.data],
		response.headers['content-disposition'],
		'file='
	);
}

export const uploadGoodServiceCodesFileUri =
	'/api/gtdcm/v1/good-service-codes/upload-gsc-file';
export async function uploadGoodServiceCodesFile(file: File) {
	const formData = new FormData();

	formData.append('file', file);

	const response = await axios.post<GoodServiceCodeFileUploadResponse>(
		uploadGoodServiceCodesFileUri,
		formData
	);

	return response.data.data;
}
